module.exports = __webpack_public_path__ + "static/media/eps-logo.0a6bd357.svg";